import { render, staticRenderFns } from "./mangopay-actions.vue?vue&type=template&id=4423d871&scoped=true"
import script from "./mangopay-actions.vue?vue&type=script&lang=js"
export * from "./mangopay-actions.vue?vue&type=script&lang=js"
import style0 from "./mangopay-actions.vue?vue&type=style&index=0&id=4423d871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423d871",
  null
  
)

export default component.exports